module.exports = __webpack_public_path__ + "img/bracket-round-right.f660005a.svg";